<div class="login-container">
  <div class="background-image" [style.background-image]="'url(' + backgroundImageUrl + ')'"></div>

  <div class="login-box">
    <div class="logo-container">
      <img [src]="logoImageUrl" alt="Logo" class="logo">
    </div>

    <form class="login-form" (ngSubmit)="realizarLogin()">
      <div class="input-group" [class.error]="usuarioErro" [class.focused]="usuarioFocado || usuario">
        <div class="input-wrapper">
          <input
            type="text"
            class="input-field"
            [(ngModel)]="usuario"
            name="usuario"
            (focus)="onUsuarioFocus()"
            (blur)="onUsuarioBlur()"
            (input)="limparErroUsuario()"
            [class.error]="usuarioErro"
          >
          <label class="floating-label">Usuário</label>
          <img
            [src]="usuarioErro ? 'assets/icons/login-edit-icon-red.png' : 'assets/icons/login-edit-icon.png'"
            alt="Editar"
            class="input-icon"
          >
        </div>
        <span class="input-caption" [class.error]="usuarioErro">
          {{ usuarioErro ? (usuarioCpfInvalido ? 'Informe um CPF válido' : 'O nome de usuário não existe') : 'Digite seu nome' }}
        </span>
      </div>

      <div class="input-group" [class.error]="senhaErro" [class.focused]="senhaFocada || senha">
        <div class="input-wrapper">
          <input
            [type]="mostrarSenha ? 'text' : 'password'"
            class="input-field"
            [(ngModel)]="senha"
            name="senha"
            (focus)="onSenhaFocus()"
            (blur)="onSenhaBlur()"
            (input)="limparErroSenha()"
            [class.error]="senhaErro"
          >
          <label class="floating-label">{{ modoAlteracaoSenha ? 'Senha atual' : 'Senha' }}</label>
          <img
            [src]="senhaErro ? 'assets/icons/login-eye-icon-red.png' : 'assets/icons/login-eye-icon.png'"
            alt="Mostrar senha"
            class="input-icon eye-icon"
            (click)="toggleMostrarSenha()"
          >
        </div>
        <span class="input-caption" [class.error]="senhaErro">
          {{ senhaErro ? 'A senha está incorreta' : (modoAlteracaoSenha ? 'Digite sua senha atual' : 'Digite sua senha') }}
        </span>
      </div>

      <div class="password-row" *ngIf="modoAlteracaoSenha">
        <div class="input-group password-half" [class.error]="novaSenhaErro" [class.focused]="novaSenhaFocada || novaSenha">
          <div class="input-wrapper">
            <input
              type="password"
              class="input-field"
              [(ngModel)]="novaSenha"
              name="novaSenha"
              (focus)="onNovaSenhaFocus()"
              (blur)="onNovaSenhaBlur()"
              (input)="limparErroNovaSenha()"
              [class.error]="novaSenhaErro"
            >
            <label class="floating-label">Nova senha</label>
          </div>
          <span class="input-caption" [class.error]="novaSenhaErro">
            {{ novaSenhaErro ? 'Digite uma nova senha válida' : 'Digite sua nova senha' }}
          </span>
        </div>

        <div class="input-group password-half" [class.error]="confirmarNovaSenhaErro" [class.focused]="confirmarNovaSenhaFocada || confirmarNovaSenha">
          <div class="input-wrapper">
            <input
              type="password"
              class="input-field"
              [(ngModel)]="confirmarNovaSenha"
              name="confirmarNovaSenha"
              (focus)="onConfirmarNovaSenhaFocus()"
              (blur)="onConfirmarNovaSenhaBlur()"
              (input)="limparErroConfirmarNovaSenha()"
              [class.error]="confirmarNovaSenhaErro"
            >
            <label class="floating-label">Confirmar nova senha</label>
          </div>
          <span class="input-caption" [class.error]="confirmarNovaSenhaErro">
            {{ confirmarNovaSenhaErro ? 'A confirmação da nova senha não confere' : 'Confirme sua nova senha' }}
          </span>
        </div>
      </div>

      <!-- Nova seção: Opções de senha -->
      <div class="password-options">
        <div class="password-option" *ngIf="!modoAlteracaoSenha" (click)="alterarSenha()">
          <span class="option-text">Alterar Senha</span>
          <img src="assets/icons/change-password-arrow.png" alt="Alterar Senha" class="option-icon">
        </div>

        <div class="password-option" *ngIf="modoAlteracaoSenha" (click)="cancelarAlteracaoSenha()">
          <img src="assets/icons/lockIcon.png" alt="Cancelar alteração" class="option-icon">
          <span class="option-text">Cancelar alteração</span>
        </div>

        <div class="password-option" (click)="esqueciSenha()">
          <span class="option-text">Esqueci a Senha</span>
          <img src="assets/icons/key-icon.png" alt="Esqueci a Senha" class="option-icon">
        </div>
      </div>

      <button type="submit" class="login-button" [disabled]="autenticando">
        {{ autenticando ? (modoAlteracaoSenha ? 'Alterando...' : 'Validando...') : (modoAlteracaoSenha ? 'Alterar' : 'Entrar') }}
      </button>

      <span class="auth-message" *ngIf="mensagemAutenticacao">
        {{ mensagemAutenticacao }}
      </span>
    </form>
  </div>

  <div class="recover-popup-backdrop" *ngIf="exibirPopupRecuperarSenha">
    <div class="recover-popup-card" role="dialog" aria-modal="true" aria-labelledby="recover-popup-title">
      <h2 id="recover-popup-title" class="recover-popup-title">Recuperar senha</h2>
      <p class="recover-popup-message">Uma nova senha foi enviada para o e-mail cadastrado.</p>
      <button type="button" class="recover-popup-ok" (click)="fecharPopupRecuperarSenha()">OK</button>
    </div>
  </div>
</div>
